UnsubscribeView = require './view.coffee'

module.exports.init = ->
  new UnsubscribeView
    el: $('#main-layout-container')
